import { addSignature, updateBetaFeatures, updatePassword } from "./actions.js"
import { loadSignatureImage } from "../../signatureImage.js";

import ItemView from "../../../components/ItemView/ItemView.vue"

export default [{
    "path": "/Home/Profile",
    "component": { ...ItemView },
    "name": "My Profile",
    "meta": {
        "app": "Home",
        "name": "My Profile",
        "sideNav": false,
        "sideNavPosition": 1,
        "sideNavSection": "Overview",
        "appSwitcher": false,
        "dataPathOverride": "user",
        "addToRecents": false,
        "menuActions": [{
            "label": "Update Password",
            "action": updatePassword
        }, {
            "label": "Add Signature",
            "action": addSignature
        }, {
            "label": "Show Beta Features",
            "action": updateBetaFeatures
        }],
        "watch": false, 
        title() {
            return "My Profile"
        },
     
        "dataFields": [{
            "label": "Name",
            "key": "Basic.name"
        }, {
            "label": "Email",
            "key": "Basic.email"
        }, {
            "label": "Department",
            "key": "Basic.department"
        }, {
            "label": "Show beta features",
            "key": "Basic.showBetaFeatures",
            "type": "bool"
        }, {
            "label": "Signature",
            "type": "image",
            async compute({ store, db }) {
                return loadSignatureImage(db, store.getters.userID, { missing: null });
            }
        }]
    }
}];
